import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import { FormAnalisaChecklistContent } from "./__MaintenanceRequestComps__";
import { useMutation, useQuery } from "react-query";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import MaintenanceRequestApi from "./__MaintenanceRequestApi__";
import {
  formInitialValues,
  formSubmitValueMapper,
  formValidationSchema,
} from "./__MaintenanceRequestUtils__";
import { Alert, DataStatus } from "components";

export const MaintenanceRequestDetail = ({ setNavbarTitle }) => {
  const history = useHistory();
  const { id } = useParams();

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: "",
    variant: "primary",
  });

  const {
    data: detailMaintenancaeRequest,
    isFetching: loadingDetailMaintenanceRequest,
  } = useQuery(
    ["maintenanceRequest", "single", id],
    () =>
      MaintenanceRequestApi.getSingle({
        id_maintenance_request: id,
      }),
    { enabled: !!id }
  );

  const createMaintenanceRequest = useMutation((data) =>
    MaintenanceRequestApi.update(data)
  );
  const formSubmitHandler = (value) => {
    createMaintenanceRequest
      .mutateAsync(formSubmitValueMapper(value))
      .then(() =>
        history.push("/transaksi/maintenance-request", {
          alert: {
            variant: "primary",
            show: true,
            text: "Data berhasil disimpan!!!",
          },
        })
      )
      .catch((err) =>
        setAlertConfig({
          variant: "danger",
          show: true,
          text: "Data gagal disimpan!!!",
        })
      );
  };

  useEffect(() => {
    setNavbarTitle("Maintenance Request");

    return () => {};
  }, []);

  return (
    <>
      <Alert
        show={alertConfig?.show}
        text={alertConfig?.text}
        variant={alertConfig?.variant}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
        showCloseButton
      />
      {loadingDetailMaintenanceRequest ? (
        <DataStatus loading text="Memuat Data..." />
      ) : (
        <Formik
          initialValues={formInitialValues(detailMaintenancaeRequest?.data)}
          onSubmit={formSubmitHandler}
          validationSchema={formValidationSchema}
        >
          <FormAnalisaChecklistContent action="detail" />
        </Formik>
      )}
    </>
  );
};
